import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import Header from './Header';
import Footer from './Footer';
import FooterResume from './FooterResume';
import Section from './Section';
import AppRun from './App.run';

// Import avatar image - will need to be adjusted based on Vite's asset handling
import avatarImage from '../assets/images/avatar-square-2024-small.jpg';

// CSS imports would be different with Vite
import '../assets/stylesheets/home.css';

const Home = () => {
  useEffect(() => {
    // Initialize the AppRun script on component mount
    AppRun();
  }, []);

  return (
    <div id='home' className='wrapper'>
      <Header />

      <Section id='profile-contact' className='section hidden-xs'>
      </Section>

      <Section id='profile' className='section'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 headline'>
              <h3>Sukhchander Khanna</h3>
              <h4>Current: Cloud + AI Solutions Engineer @ <a href='https://azure.microsoft.com/' target='_blank' rel="noopener noreferrer">Microsoft Azure</a> guiding teams at <a href='https://build.nvidia.com/' target='_blank' rel="noopener noreferrer">Nvidia</a>, <a href='https://www.intel.com/' target='_blank' rel="noopener noreferrer">Intel</a>, and <a href='https://www.amd.com/' target='_blank' rel="noopener noreferrer">AMD</a> on Azure by driving GTM pre-sales</h4>
              <h4>Previous: Solutions Architect @ <a href='https://aws.amazon.com/' target='_blank' rel="noopener noreferrer">Amazon Web Services</a> guiding teams at <a href='https://www.apple.com/' target='_blank' rel="noopener noreferrer">Apple</a> on AWS</h4>
            </div>

            <div className='col-md-3 col-sm-3'>
              <img className='avatar' alt='avatar' src={avatarImage} />
              <div className="">
                <a href="/resume" className='btn btn-default'>
                  View resume&nbsp;&nbsp;<i className='fa fa-sign-in'></i>
                </a>
              </div>
              <br/>
            </div>

            <div className='col-md-9 col-sm-9'>
              <h4>I guide cloud engineering teams at <a href='https://build.nvidia.com/' target='_blank' rel="noopener noreferrer">Nvidia</a>, <a href='https://www.intel.com/' target='_blank' rel="noopener noreferrer">Intel</a>, and <a href='https://www.amd.com/' target='_blank' rel="noopener noreferrer">AMD</a> migrate, modernize, optimize, and effectively operate AI/ML workloads on Azure. I influence <b>$100M+</b> in ARR across Azure infrastructure services by driving GTM pre-sales.</h4>
              <h4>Prior to Azure I was a Solutions Architect at AWS for 7 years where I helped 28 account managers to attain <b>$500M+</b> in revenue. I helped several Apple business units modernize and optimize AI/ML workloads on AWS. I also helped 200+ customers in the Strategic, Startup, SMB, DNB, and Enterprise segments across industries (Healthcare, AdTech, EdTech, Retail, Hardware, Ecommerce, and Private Equity) achieve successful business outcomes by strategically engaging VPs, CIOs, CISOs, and CTOs.</h4>
              <hr className='hidden-xs' />
            </div>

            <div className='col-md-9 col-sm-9'>

              <div className='profile-widget'>

                <h5>Solution Engineering, Strategic Solution Framing, and GTM Value Selling</h5>
                <div className='skill-bar'>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-off'></div>
                </div>

                <h5>Cloud Computing (AWS, Azure, GCP, Migrations, Modernization, Optimization)</h5>
                <div className='skill-bar'>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-off'></div>
                  <div className='skill-rate-off'></div>
                </div>

                <h5>Software Development: Node, Python, React, EKS/AKS/GKE/k8s, HPC, Serverless</h5>
                <div className='skill-bar'>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-off'></div>
                  <div className='skill-rate-off'></div>
                  <div className='skill-rate-off'></div>
                  <div className='skill-rate-off'></div>
                  <div className='skill-rate-off'></div>
                </div>

                <h5>AI/ML Development: Inference, Training, GenAI, Agents</h5>
                <div className='skill-bar'>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-on'></div>
                  <div className='skill-rate-off'></div>
                  <div className='skill-rate-off'></div>
                  <div className='skill-rate-off'></div>
                  <div className='skill-rate-off'></div>
                  <div className='skill-rate-off'></div>
                  <div className='skill-rate-off'></div>
                  <div className='skill-rate-off'></div>
                </div>

              </div>

              <div className='profile-widget'>
                <ul className='widget-social'>
                  <li>
                    <a href='//www.github.com/sukhchander' target='_blank' rel="noopener noreferrer">
                      <i className='fa fa-github'></i>
                    </a>
                  </li>
                  <li>
                    <a href='//www.twitter.com/sukhchander' target='_blank' rel="noopener noreferrer">
                      <i className='fa fa-twitter'></i>
                    </a>
                  </li>
                  <li>
                    <a href='//www.linkedin.com/in/sukhchander' target='_blank' rel="noopener noreferrer">
                      <i className='fa fa-linkedin'></i>
                    </a>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </Section>

      <Section id='connect' className='section'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 headline hidden-xs'>
              <h3>Connect</h3>
            </div>

            <div className='col-md-3'>
              <ul className='icon-list'>
                <li><i className='fa fa-fw fa-envelope-o icon-before'></i><a href='mailto:sukhchander+www@gmail.com'> email</a></li>
                <li><i className='fa fa-fw fa-github icon-before'></i><a href='//www.github.com/sukhchander' target='_blank' rel="noopener noreferrer"> github</a></li>
                <li><i className='fa fa-fw fa-twitter icon-before'></i><a href='//www.twitter.com/sukhchander' target='_blank' rel="noopener noreferrer"> twitter</a></li>
                <li><i className='fa fa-fw fa-linkedin icon-before'></i><a href='//www.linkedin.com/in/sukhchander' target='_blank' rel="noopener noreferrer"> linkedin</a></li>
                <li><i className='fa fa-fw fa-globe icon-before'></i><a href='//www.sukhchander.com'> sukhchander.com</a></li>
              </ul>
            </div>

            <div className='col-md-9'>
              <form id='contact-form' role='form'>
                <div className='form-group'>
                  <label className='sr-only'>Name</label>
                  <input type='text' id='name' className='form-control' name='name' placeholder='Name' />
                </div>

                <div className='form-group'>
                  <label className='sr-only'>Email</label>
                  <input type='email' id='email' className='form-control' name='email' placeholder='E-mail' />
                </div>

                <div className='form-group'>
                  <textarea className='form-control' id='message' name='message' rows='7' placeholder='Message'></textarea>
                </div>

                <button type='submit' className='btn btn-custom-1'>
                  <i className='fa fa-paper-plane-o icon-before'></i> Send
                </button>
              </form>

              <div className='ajax-response'></div>
            </div>
          </div>
        </div>
      </Section>

      <FooterResume />
    </div>
  );
};

export default Home;